export default __webpack_public_path__ + "static/jor-smallbatch2-c63fc2c41240a8a2291b4f6259d449e5.jpg";